// WARNING: these values are USED with chrome extension (careful on updating)
export const AVATAR_ID_COOKIE = 'bitmoji_avatar_id';
export const AVATAR_UUID_COOKIE = 'bitmoji_avatar_uuid';
export const BSAUTH_COOKIE = 'bitmoji_bsauth_token';
export const LOGIN_TOKEN_TYPE_COOKIE = 'bitmoji_login_token_type';
export const LOGIN_TOKEN_TYPE_BSAUTH = 'bsAuth';
export const LOGIN_TOKEN_TYPE_SNAPCHAT = 'snapAuth';


// WEBPACK FOOTER //
// ./src/constants/cookie_constants.js